var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdv2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 60,
    viewBox: "0 0 97 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_696_100780)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.100586 28.1669C0.100586 26.7112 1.06708 25.2554 3.00008 24.1447L41.5001 2.02223C45.366 -0.199162 51.6341 -0.199202 55.5001 2.02223L94 24.1447C95.933 25.2554 96.899 26.7111 96.899 28.1669V32.1892C96.899 30.7334 95.933 29.2776 94 28.1669L55.5001 6.04449C51.6341 3.82306 45.366 3.8231 41.5001 6.04449L3.00008 28.1669C1.06708 29.2776 0.100586 30.7334 0.100586 32.1892V28.1669Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_696_100780)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.899 28.1671C96.899 29.6229 95.933 31.0787 94 32.1894L55.5001 54.3118C51.6341 56.5333 45.366 56.5332 41.5001 54.3118L3.00008 32.1894C1.06708 31.0787 0.100586 29.6229 0.100586 28.1671V32.1894C0.100586 33.6451 1.06708 35.1009 3.00008 36.2116L41.5001 58.3341C45.366 60.5555 51.6341 60.5555 55.5001 58.3341L94 36.2116C95.933 35.1009 96.899 33.6452 96.899 32.1894V28.1671Z",
    fill: "url(#paint0_linear_696_100780)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.6671 2.12778L3.18368 24.2407C-0.590133 26.4091 -0.590133 29.9249 3.18368 32.0934L41.6671 54.2063C45.4409 56.3747 51.5595 56.3747 55.3333 54.2063L93.8167 32.0934C97.5905 29.9249 97.5905 26.4091 93.8167 24.2407L55.3333 2.12778C51.5595 -0.040689 45.4409 -0.0406878 41.6671 2.12778Z",
    fill: "white",
    stroke: "#EBF4FF",
    strokeWidth: 0.404145
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8911 19.502C34.8477 19.5081 34.0044 19.995 33.9938 20.5974L33.9525 22.9329L30.4699 24.1213C29.5716 24.4278 29.2629 25.0928 29.7754 25.6176L31.7622 27.6521L29.7754 29.6866C29.2629 30.2114 29.5716 30.8765 30.4699 31.183L33.9525 32.3714L33.9938 34.7069C34.0044 35.3093 34.8477 35.7961 35.8911 35.8023L39.9363 35.8261L41.9946 37.8368C42.5255 38.3554 43.6774 38.5336 44.5864 38.2378L48.1103 37.0907L51.6342 38.2378C52.5431 38.5336 53.695 38.3554 54.2259 37.8368L56.2843 35.8261L60.3295 35.8023C61.3729 35.7961 62.2161 35.3093 62.2268 34.7069L62.2681 32.3714L65.7507 31.183C66.649 30.8765 66.9576 30.2114 66.4451 29.6866L64.4583 27.6521L66.4451 25.6176C66.9576 25.0928 66.649 24.4278 65.7507 24.1213L62.2681 22.9329L62.2268 20.5974C62.2161 19.995 61.3729 19.5081 60.3295 19.502L56.2843 19.4781L54.2259 17.4674C53.695 16.9488 52.5431 16.7706 51.6342 17.0665L48.1103 18.2136L44.5864 17.0665C43.6774 16.7706 42.5256 16.9488 41.9946 17.4674L39.9363 19.4781L35.8911 19.502ZM37.7752 23.5794L37.8084 21.7043L41.0562 21.6852C41.727 21.6812 42.3455 21.4751 42.6869 21.1416L44.3395 19.5273L47.1688 20.4482C47.7532 20.6385 48.4673 20.6385 49.0518 20.4482L51.881 19.5273L53.5337 21.1416C53.875 21.4751 54.4935 21.6812 55.1644 21.6852L58.4122 21.7043L58.4454 23.5794C58.4522 23.9668 58.8093 24.3238 59.3868 24.5209L62.183 25.4751L60.5878 27.1086C60.2583 27.446 60.2583 27.8583 60.5878 28.1957L62.183 29.8292L59.3868 30.7833C58.8093 30.9804 58.4522 31.3375 58.4454 31.7248L58.4122 33.5999L55.1644 33.6191C54.4935 33.623 53.875 33.8292 53.5337 34.1627L51.881 35.777L49.0518 34.856C48.4673 34.6658 47.7532 34.6658 47.1688 34.856L44.3395 35.777L42.6869 34.1627C42.3455 33.8292 41.727 33.623 41.0562 33.6191L37.8084 33.5999L37.7752 31.7248C37.7683 31.3375 37.4113 30.9804 36.8337 30.7833L34.0376 29.8292L35.6328 28.1957C35.9623 27.8583 35.9623 27.446 35.6328 27.1086L34.0376 25.4751L36.8337 24.5209C37.4113 24.3238 37.7683 23.9668 37.7752 23.5794ZM39.0735 28.6956C38.0753 28.1193 38.0754 27.1849 39.0735 26.6086C40.0717 26.0323 41.6901 26.0323 42.6883 26.6086C43.6865 27.1849 43.6864 28.1193 42.6883 28.6956C41.6901 29.2719 40.0717 29.2719 39.0735 28.6956ZM50.3012 31.826C50.3012 32.5246 49.3203 33.0909 48.1103 33.0909C46.9003 33.0909 45.9195 32.5246 45.9195 31.826L45.9196 23.4781C45.9196 22.7796 46.9005 22.2132 48.1105 22.2132C49.3205 22.2132 50.3013 22.7795 50.3013 23.4781L50.3012 31.826ZM53.5323 28.6956C52.5341 28.1193 52.5341 27.185 53.5323 26.6087C54.5305 26.0324 56.1489 26.0324 57.147 26.6087C58.1452 27.185 58.1452 28.1193 57.147 28.6956C56.1488 29.2719 54.5304 29.2719 53.5323 28.6956Z",
    fill: "#3399CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_696_100780",
    x: 0.100586,
    y: 28.1671,
    width: 96.7983,
    height: 34.2579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21244
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_696_100780"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42487
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42487
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_696_100780",
    result: "effect2_innerShadow_696_100780"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42487
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.04145
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_696_100780",
    result: "effect3_innerShadow_696_100780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_100780",
    x1: 0.100586,
    y1: 28.1671,
    x2: 24.9289,
    y2: 88.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3399CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AED6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3399CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_696_100780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdv2);
export default __webpack_public_path__ + "static/media/adv-2.9991c8dccd39bf1df86f046544fd6979.svg";
export { ForwardRef as ReactComponent };